// Importing action types and initial state
import * as types from "../Actions/ActionTypes";
import initialState from "./initailState";

// Reducer function to manage payout-related state
const table = (state = initialState.table, action) => {
  switch (action.type) {
  case types.GET_AGENT_HIERARCHY_CALL:
    return { ...state, loading: true };
  case types.GET_AGENT_HIERARCHY_CALL_SUCCESS:
    return { ...state, loading: false, agentList: action.data };
  case types.GET_AGENT_HIERARCHY_CALL_ERROR:
    return { ...state, error: true, loading: false };
  case types.GET_MERCHANT_HIERARCHY_CALL:
    return { ...state, loading: true };
  case types.GET_MERCHANT_HIERARCHY_CALL_SUCCESS:
    return { ...state, loading: false, merchantList: action.data };
  case types.GET_MERCHANT_HIERARCHY_CALL_ERROR:
    return { ...state, error: true, loading: false };
  default:
    return state;
  }
};

export default table;
